var site = site || {};

site.adverts = {
	init: function() {
		console.log('here');
		if($('#region_id').val() != 4) {
			$('[id^=icon-element]').addClass('hide');
			$('[id^=icon-label]').addClass('hide');
		}
		$('#region_id').change(function() {
			if($(this).val() != 4) {
				$('[id^=icon-element]').addClass('hide');
				$('[id^=icon-label]').addClass('hide');
			}
			else {
				$('[id^=icon-element]').removeClass('hide');
				$('[id^=icon-label]').addClass('hide');
			}
		});
	}
};
